<script>
  import { fetchUserBackendConfig, fetchUserFrontendConfig, saveUserBackendConfig, saveUserFrontendConfig } from '../configApi';

  import Configuration from './Configuration.svelte';
  import WidgetPreview from './WidgetPreview.svelte';
  import CtaPreview from './CtaPreview.svelte';
  import CarouselPreview from './CarouselPreview.svelte';
  import { notifications, Checkbox } from '@shopboxai/sb-portal-components';
  import Index from '../Index.svelte';

  let backendConfigs;
  let frontendConfigs;
  let show_save = false;
  let config = {
    backend: {
      filters: {},
    },
    frontend: {
      locale: { code: {} },
    },
  };
  const _fetchUserBackendConfig = async () => {
    backendConfigs = await fetchUserBackendConfig();
    config.backend.filters = { ...(backendConfigs.filters || {}) };
    if (!config.backend.filters.brand) {
      config.backend.filters.brand = '';
    }
    config.backend.price_restrict = backendConfigs.price_restrict || 0;
  };

  const _fetchUserFrontendConfig = async () => {
    frontendConfigs = await fetchUserFrontendConfig();

    config.frontend.logo = frontendConfigs.logo;
    config.frontend.maincolor = frontendConfigs.maincolor;
    config.frontend.powered_by = frontendConfigs.powered_by;
    config.frontend.locale.code = JSON.parse(frontendConfigs.locale?.code || '{}');
  };

  let runFetchUserBackendConfig;
  let runFetchUserFrontendConfig;

  const fetchData = () => {
    show_save = false;
    runFetchUserBackendConfig = _fetchUserBackendConfig();
    runFetchUserFrontendConfig = _fetchUserFrontendConfig();
  };

  const saveData = async () => {
    if (!backendConfigs.filters && config.backend.filters) {
      backendConfigs.filters = {};
    }

    if (backendConfigs.filters?.brand || config.backend.filters.brand) {
      backendConfigs.filters.brand = config.backend.filters.brand.split(',');
    }
    if (backendConfigs.filters?.age || config.backend.filters.age) {
      backendConfigs.filters.age = config.backend.filters.age;
    }
    if (backendConfigs.filters?.size || config.backend.filters.size) {
      backendConfigs.filters.size = config.backend.filters.size;
    }
    if (backendConfigs.filters?.stock || config.backend.filters.stock) {
      backendConfigs.filters.stock = config.backend.filters.stock;
    }
    if (config.backend.price_restrict || backendConfigs.price_restrict) {
      backendConfigs.price_restrict = config.backend.price_restrict;
    }

    if (config.frontend.logo || frontendConfigs.logo) {
      frontendConfigs.logo = config.frontend.logo;
    }
    if (config.frontend.maincolor || frontendConfigs.maincolor) {
      frontendConfigs.maincolor = config.frontend.maincolor;
    }
    if (config.frontend.powered_by || frontendConfigs.powered_by) {
      frontendConfigs.powered_by = config.frontend.powered_by;
    }

    if (!frontendConfigs.locale?.code) {
      frontendConfigs.locale = {
        lang: 'JSON',
      };
    }
    frontendConfigs.locale.code = JSON.stringify(config.frontend.locale.code);

    notifications.info('Saving configurations', 1000);
    await saveUserBackendConfig(backendConfigs);
    await saveUserFrontendConfig(frontendConfigs);
    fetchData();
    notifications.info('Saved', 1000);
  };

  fetchData();

  const handleInput = () => {
    show_save = true;
  };

  const handleTranslationsInput = () => {
    for (const key in config.frontend.locale.code) {
      if (!config.frontend.locale.code[key]) {
        delete config.frontend.locale.code[key];
      }
    }
    show_save = true;
  };
</script>

{#await runFetchUserBackendConfig}
  Loading
{:then}
  <div class="settings-wrapper">
    <section>
      <h3 class="first">Filter Options</h3>
      <Configuration title="Brand list" subtitle="Only products in stock will be displayed.">
        <input slot="content" type="text" placeholder="Adidas,Fila,Nike" bind:value={config.backend.filters.brand} on:input={handleInput} />
      </Configuration>
      <Configuration title="Stock" subtitle="Only products in stock will be displayed.">
        <Checkbox bind:value={config.backend.filters.stock} on:input={handleInput} slot="content" />
      </Configuration>
      <Configuration title="Age" subtitle="Description of the option.">
        <Checkbox bind:value={config.backend.filters.age} on:input={handleInput} slot="content" />
      </Configuration>
      <Configuration title="Size" subtitle="Display products with same size.">
        <Checkbox bind:value={config.backend.filters.size} on:input={handleInput} slot="content" />
      </Configuration>

      <Configuration title="Price" subtitle="Display products within specified price range.">
        <div slot="content" class="flex range">
          <input type="range" min="0.0" max="1.0" step="0.1" bind:value={config.backend.price_restrict} on:input={handleInput} />
          <span class="range-value">{config.backend.price_restrict * 100} %</span>
        </div>
      </Configuration>
    </section>
  </div>
{:catch}
  No configs
{/await}

{#await runFetchUserFrontendConfig}
  <p />
{:then}
  <div class="settings-wrapper">
    <section>
      <div class="widget-preview">
        <WidgetPreview
          color={config.frontend.maincolor}
          showPoweredBy={config.frontend.powered_by}
          imgUrl={config.frontend.logo}
          sbGreeting={config.frontend.locale.code.widget_title}
          sbSlogan={config.frontend.locale.code.widget_subtitle}
          recentText={config.frontend.locale.code.recent_widget}
          similarText={config.frontend.locale.code.similar_widget}
        />
      </div>
      <h3>Widget styles</h3>
      <Configuration title="Logo" subtitle="Specify the url of your logo">
        <input slot="content" type="text" placeholder="https://mylogo.com" bind:value={config.frontend.logo} on:input={handleInput} />
      </Configuration>

      <Configuration title="Primary color" subtitle="Change the color of the header and buttons">
        <input slot="content" type="text" bind:value={config.frontend.maincolor} on:input={handleInput} />
      </Configuration>

      <Configuration title="Hide 'Powered by Shopbox'">
        <Checkbox bind:value={config.frontend.powered_by} on:input={handleInput} slot="content" />
      </Configuration>
    </section>

    <section>
      <h3>Widget translations</h3>

      <Configuration title="Title">
        <input
          slot="content"
          type="text"
          placeholder="Hi"
          bind:value={config.frontend.locale.code.widget_title}
          on:input={handleTranslationsInput}
        />
      </Configuration>
      <Configuration title="Subtitle">
        <input
          slot="content"
          type="text"
          placeholder="I am your personal shopping assistant"
          bind:value={config.frontend.locale.code.widget_subtitle}
          on:input={handleTranslationsInput}
        />
      </Configuration>
      <Configuration title="Recent widget">
        <input
          slot="content"
          type="text"
          placeholder="Recently Viewed Items"
          bind:value={config.frontend.locale.code.recent_widget}
          on:input={handleTranslationsInput}
        />
      </Configuration>
      <Configuration title="Similar widget">
        <input
          slot="content"
          type="text"
          placeholder="Similar Products"
          bind:value={config.frontend.locale.code.similar_widget}
          on:input={handleTranslationsInput}
        />
      </Configuration>
    </section>

    <section class="cta-settings">
      <CtaPreview CtaSimilarText={config.frontend.locale.code.similar_cta} CtaRecentText={config.frontend.locale.code.recent_cta} />
      <h3>CTA pop up</h3>
      <Configuration title="Similar CTA">
        <input
          slot="content"
          type="text"
          placeholder="Want to see similar products?"
          bind:value={config.frontend.locale.code.similar_cta}
          on:input={handleTranslationsInput}
        />
      </Configuration>
      <Configuration title="Recent CTA">
        <input
          slot="content"
          type="text"
          placeholder="Products you've recently viewed"
          bind:value={config.frontend.locale.code.recent_cta}
          on:input={handleTranslationsInput}
        />
      </Configuration>
    </section>
    <section class="carousel-settings">
      <CarouselPreview
        similar={config.frontend.locale.code.similar_embed}
        recent={config.frontend.locale.recent_embed}
        recommended={config.frontend.locale.recommended_embed}
        boughtTogether={config.frontend.locale.frequentlyBoughtTogether_embed}
      />
      <h3>Carousel embeds</h3>
      <Configuration title="Similar products">
        <input
          slot="content"
          type="text"
          placeholder="Other products you may like"
          bind:value={config.frontend.locale.code.similar_embed}
          on:input={handleTranslationsInput}
        />
      </Configuration>
      <Configuration title="Recently viewed">
        <input
          slot="content"
          type="text"
          placeholder="Recently viewed products"
          bind:value={config.frontend.locale.recent_embed}
          on:input={handleTranslationsInput}
        />
      </Configuration>
      <Configuration title="Recommended products">
        <input
          slot="content"
          type="text"
          placeholder="Recommended for you"
          bind:value={config.frontend.locale.recommended_embed}
          on:input={handleTranslationsInput}
        />
      </Configuration>
      <Configuration title="Bought together">
        <input
          slot="content"
          type="text"
          placeholder="Frequently Bought Together"
          bind:value={config.frontend.locale.frequentlyBoughtTogether_embed}
          on:input={handleTranslationsInput}
        />
      </Configuration>
    </section>
  </div>
  <footer>
    <div class="footer-wrapper">
      <button
        class="secondary {show_save ? '' : 'hidden'}"
        on:click={() => {
          fetchData();
        }}
      >
        Discard Changes
      </button>
      <button
        class="primary"
        disabled={!show_save}
        on:click={() => {
          saveData();
        }}
      >
        Save Changes
      </button>
    </div>
  </footer>
{:catch}
  No frontend configs
{/await}

<style>.settings-wrapper{max-width:600px;position:relative}.carousel-settings,.cta-settings{position:relative}.widget-preview{position:-webkit-sticky;position:sticky;top:3.2em}.flex{display:flex}section{margin-bottom:3em}input[type=text]{border:1px solid #d0d0d2;border-radius:3px;height:60%;padding:12px 8px;width:50%}.range span{margin-left:10px}h3{background-color:#fff;color:var(--t-l-c);padding-bottom:1em;padding-top:1em;position:-webkit-sticky;position:sticky;top:50px}.hidden{display:none}footer{align-self:flex-end;background-color:#fff;border-top:1px solid var(--brd-l);bottom:0;box-shadow:0 6px 14px -6px rgba(24,39,75,.12),0 10px 32px -4px rgba(24,39,75,.1);margin:0 0 -1em -1em;padding:.5em 1em;position:-webkit-sticky;position:sticky;width:calc(100% + 2em);z-index:2}.footer-wrapper>.secondary{border:1px solid;margin-right:1em}.footer-wrapper{display:flex;justify-content:flex-end}.range-value{min-width:45px}input[type=range]{-webkit-appearance:none;background:var(--brd-l);border-radius:15px;height:7px;margin-top:.5em;width:200px}input[type=range]::-moz-range-thumb{-webkit-appearance:none;background:#fff;border:1px solid var(--h-c);border-radius:50%;height:16px;width:16px}input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;background:#fff;border:1px solid var(--h-c);border-radius:50%;height:16px;width:16px}input[type=range]::-moz-range-progress{background:var(--h-c);border-radius:15px;height:7px}input[type=range]::-ms-fill-lower{background:var(--h-c);border-radius:10px}input[type=range]::-ms-fill-upper{background:#ddd;border-radius:10px}input[type=range]::-ms-thumb{-webkit-appearance:none;background:#fff;border:1px solid var(--h-c);border-radius:50%;height:16px;width:16px}@media (max-width:640px){h3{top:100px;z-index:1}}@media (max-width:450px){input[type=text]{margin-top:.3em;width:100%}input[type=range]{width:85%}}</style>
